"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Alert = function Alert(_a) {
  var type = _a.type,
      content = _a.content,
      children = _a.children,
      className = _a.className;

  var _b;

  if (!content && !children) return react_1.default.createElement(react_1.Fragment, null);
  return react_1.default.createElement("div", {
    className: classnames_1.default('alert', (_b = {}, _b["alert-" + type] = !!type, _b), className)
  }, content || children);
};

exports.default = Alert;